export default {"src":"/_next/static/media/appStoreBlack.83e4404f.svg","height":48,"width":144};